import { type OptionsFetchQueryResult, OptionsType } from '@openx/types/options.ts';
import type { UseQueryOptions } from '@openx/types/reactQuery.ts';
import { useTranslation } from 'react-i18next';

import { useOptionsFetch } from './generics/useOptionsFetch.tsx';

export function useTargetingLanguagesOptionsFetch(queryOptions?: UseQueryOptions<OptionsFetchQueryResult>) {
  const { t } = useTranslation();
  const {
    isLoading: isTargetingLanguagesLoading,
    data: targetingLanguages,
    refetch: refetchTargetingLanguages,
  } = useOptionsFetch({
    errorMessage: t('Failed to fetch targeting languages'),
    optionType: OptionsType.TARGETING_LANGUAGE,
    queryOptions,
  });

  return {
    isTargetingLanguagesLoading,
    refetchTargetingLanguages,
    targetingLanguages,
  };
}
